import _extends from "@babel/runtime-corejs2/helpers/esm/extends";
import _objectWithoutProperties from "@babel/runtime-corejs2/helpers/esm/objectWithoutProperties";
/**
 *
 * RadioButton Base
 *
 * Wrapper around the Input component to provide a basic radio button input
 *
 */

import React from 'react';
import classNames from 'classnames';
import Input from '../../../../atoms/Input';

var Base = function Base(_ref) {
  var id = _ref.id,
      name = _ref.name,
      onChange = _ref.onChange,
      value = _ref.value,
      className = _ref.className,
      extraProps = _objectWithoutProperties(_ref, ["id", "name", "onChange", "value", "className"]);

  return React.createElement(Input, _extends({
    "aria-describedby": "radio__label--".concat(id),
    className: classNames('radio__input', className),
    id: id,
    name: name,
    onChange: onChange,
    type: "radio",
    value: value
  }, extraProps));
};

Base.defaultProps = {
  value: ''
};
export default Base;